<template>
  <div>
    <el-dialog
      title="添加内容"
      :visible="dialogVisible"
      :before-close="handleClose"
    >
      <div style="width: 300px; display: flex; justify-content: left">
        <el-input
          v-model="tableDataParams.title"
          placeholder="请输入名称"
          size="small"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getTableData"
          ></el-button>
        </el-input>
      </div>
      <el-tabs v-model="activeName" @tab-click="changeTab">
        <el-tab-pane label="资料" name="document">
          <el-table
            ref="documentTable"
            v-loading="tableData.loading"
            :data="tableData.data"
            row-key="documentId"
            @select="tableSelectionChange"
          >
            <el-table-column
              class-name="addDocumentSelectAllColumn"
              :show-overflow-tooltip="true"
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="left"
              label="资料名称"
              prop="title"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            v-show="tableData.total > 10"
            background
            style="text-align: right; padding: 10px"
            :current-page.sync="tableDataParams.pageIndex"
            layout="slot,->,total, prev, pager, next"
            :total="tableData.total"
            :page-size="10"
            @current-change="changeIndex"
          >
            <span class="el-pagination__total" style="display: flex">
              已选：{{ selectedDocuments.length + selectedVideos.length }}
            </span>
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="视频" name="video">
          <el-table
            ref="videoTable"
            v-loading="tableData.loading"
            :data="tableData.data"
            @select="tableSelectionChange"
          >
            <el-table-column
              class-name="addDocumentSelectAllColumn"
              :show-overflow-tooltip="true"
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="left"
              label="视频名称"
              prop="title"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            v-show="tableData.total !== null && tableData.total !== 0"
            background
            style="text-align: right; padding: 10px"
            :current-page.sync="tableDataParams.pageIndex"
            layout="slot,->,total, prev, pager, next"
            :total="tableData.total"
            :page-size="10"
            @current-change="changeIndex"
          >
            <span class="el-pagination__total" style="display: flex">
              已选：{{ selectedDocuments.length + selectedVideos.length }}
            </span>
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button @click="confirmSelect" type="primary">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "ShopCenterAdminWebRecourseSelectDialog",
  props: {
    courseId: {
      type: [String, Number],
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },

    selectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: "document",
      dialogVisible: false,
      tableDataParams: {
        courseId: "",
        queryType: 1,
        shopId: this.$store.state.user.userInfo.shopId,
        title: "",
        pageSize: 10,
        pageIndex: 1,
        sortRule: "create_time$2",
      },
      tableData: {
        total: 0,
        data: [],
        loading: false,
      },
      selectedDocuments: [], // 选中的资料
      selectedVideos: [], // 选中的视频
    };
  },

  watch: {
    selectData: {
      handler: function (val) {
        this.selectedDocuments = val.selectedDocuments;
        this.selectedVideos = val.selectedVideos;
      },
      deep: true,
      immediate: true,
    },
    show: {
      handler: function (val) {
        this.dialogVisible = val;
        if (val) {
          this.getTableData();
        }
      },
    },
  },

  mounted() {},

  methods: {
    // 获取表格数据
    async getTableData() {
      // 如果课程id为空，则不请求数据
      if (!this.courseId) return;
      this.tableDataParams.courseId = this.courseId;
      this.tableData.loading = true;
      const res = await this.$axios.post(
        api.decoration.getVideoOrResourceList,
        this.tableDataParams
      );
      if (res) {
        this.tableData.total = res.totalCount;
        this.tableData.data = res.list
          ? res.list.map((item) => {
              item.courseId = this.courseId;
              return item;
            })
          : [];
        this.tableData.loading = false;
        this.$nextTick(() => {
          this.tableData.data.forEach((item) => {
            if (this.activeName === "document") {
              const index = this.selectedDocuments.findIndex(
                (item2) => item2.documentId === item.documentId
              );
              if (index !== -1) {
                this.$refs.documentTable.toggleRowSelection(item, true);
              }
            } else {
              const index = this.selectedVideos.findIndex(
                (item2) => item2.documentId === item.documentId
              );
              if (index !== -1) {
                this.$refs.videoTable.toggleRowSelection(item, true);
              }
            }
          });
        });
      }
    },
    // 切换资料类型
    async changeTab() {
      this.tableDataParams.pageIndex = 1;
      this.tableData.data = [];
      this.tableData.total = 0;
      this.$refs.documentTable && this.$refs.documentTable.clearSelection();
      this.$refs.videoTable && this.$refs.videoTable.clearSelection();
      if (this.activeName === "document") {
        this.tableDataParams.queryType = 1;
      } else {
        this.tableDataParams.queryType = 2;
      }
      await this.getTableData();
    },
    // 切换页码
    async changeIndex(pageIndex) {
      this.tableDataParams.pageIndex = pageIndex;
      // 请求数据
      await this.getTableData();
    },
    // 关闭弹窗
    closeDialog() {
      // 恢复默认数据
      this.activeName = "document";
      this.tableDataParams.pageIndex = 1;
      this.tableDataParams.title = "";
      this.tableDataParams.queryType = 1;
      this.tableData.data = [];
      this.tableData.total = 0;
      this.selectedDocuments = [];
      this.selectedVideos = [];
      this.$refs.documentTable && this.$refs.documentTable.clearSelection();
      this.$refs.videoTable && this.$refs.videoTable.clearSelection();
      this.$emit("update:show", false);
    },
    // 关闭弹窗
    handleClose(done) {
      this.closeDialog();
      done();
    },
    // 选择数据
    tableSelectionChange(selection, row) {
      // console.log("selection--", selection);
      console.log(row);
      if (this.activeName === "document") {
        this.selectedDocuments = JSON.parse(JSON.stringify(selection));
      } else {
        this.selectedVideos = JSON.parse(JSON.stringify(selection));
      }
    },
    // 确定选择的数据
    confirmSelect() {
      this.$emit("confirmSelect", {
        selectedDocuments: this.selectedDocuments,
        selectedVideos: this.selectedVideos,
      });
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-dialog__header {
  text-align: left;
}

::v-deep .el-table__header-wrapper .addDocumentSelectAllColumn .el-checkbox {
  display: none;
}
</style>
